
import { Component, Prop, Vue } from 'vue-property-decorator';
import { applicationDetailsInfoType, reportInfoType } from '@/types/Common';

@Component
export default class SummaryTable extends Vue {

    @Prop({required:true})
    results!: reportInfoType;
       
    dataReady = false;
    applicationDetailsInfo = {} as applicationDetailsInfoType; 
   
    mounted(){
        this.dataReady = false;
        this.extractInfo();       
        this.dataReady = true;
    }    

    public extractInfo(){
        this.applicationDetailsInfo = this.results.application_details;
    }   
 
}
